/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesPl = {
  privacy: {
    pageTitle: "Polityka prywatności",
    lastUpdated: "Ostatnia aktualizacja: 1 czerwca 2026",
    introduction: {
      title: "Wprowadzenie",
      body: "WasOK to lokalna aplikacja wspomagająca zakupy, zaprojektowana, aby pomóc użytkownikom pamiętać produkty, które wcześniej kupili, ocenili lub zrecenzowali.\n\nNiniejsza Polityka prywatności wyjaśnia, jakie informacje są przetwarzane podczas korzystania z aplikacji, jak dane są przechowywane oraz jak mogą działać wybrane usługi stron trzecich.",
    },
    dataStored: {
      title: "Dane przechowywane przez aplikację",
      body: "WasOK przechowuje następujące informacje lokalnie na Twoim urządzeniu:\n\n• zeskanowane kody kreskowe produktów\n• nazwy i szczegóły produktów wprowadzone przez użytkownika\n• oceny i komentarze\n• listy zakupów\n• kategorie produktów\n• ceny i informacje o sklepach\n• zdjęcia produktów i sklepów\n\nTwoje dane produktów i zdjęcia nie są przesyłane na serwery WasOK.",
    },
    permissions: {
      title: "Używane uprawnienia",
      camera: {
        title: "Aparat",
        body: "Dostęp do aparatu jest używany do:\n\n• skanowania kodów kreskowych\n• robienia zdjęć produktów",
      },
      photos: {
        title: "Zdjęcia i multimedia",
        body: "Dostęp do zdjęć lub galerii jest używany tylko gdy:\n\n• dołączasz obrazy do produktów\n• przywracasz kopie zapasowe zawierające zdjęcia",
      },
      files: {
        title: "Dostęp do plików i pamięci",
        body: "Dostęp do plików może być używany do:\n\n• eksportowania plików kopii zapasowych\n• importowania kopii zapasowych wybranych przez użytkownika\n• udostępniania list zakupów lub kopii zapasowych",
      },
    },
    backup: {
      title: "Kopie zapasowe i eksport",
      body: "WasOK umożliwia użytkownikom tworzenie plików kopii zapasowych zawierających dane aplikacji oraz opcjonalnie zdjęcia.\n\nPliki kopii zapasowych są tworzone lokalnie na Twoim urządzeniu i mogą być przechowywane lub udostępniane za pomocą usług wybranych przez użytkownika, takich jak:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokalna pamięć urządzenia\n\nWasOK nie przesyła kopii zapasowych na własne serwery.",
      onlineProductLookup: {
        title: "Wyszukiwanie produktów online",
        body: "Gdy włączysz wyszukiwanie kodów kreskowych online w Preferencjach, WasOK może wysłać wyłącznie zeskanowany numer kodu kreskowego do publicznych baz produktów (takich jak Open Food Facts), aby zasugerować nazwę i markę produktu. WasOK nie przesyła Twoich ocen, komentarzy, zdjęć, list zakupów, kategorii, informacji o sklepach ani danych kopii zapasowych w ramach tej funkcji. Możesz wyłączyć to w dowolnym momencie w Preferencjach.",
      },
    },
    advertising: {
      title: "Reklamy i usługi stron trzecich",
      intro:
        "WasOK korzysta z wybranych usług stron trzecich, aby zapewnić określone funkcje.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob jest używany do wyświetlania reklam w aplikacji.\n\nGoogle i jego partnerzy mogą przetwarzać informacje takie jak:\n\n• identyfikatory reklamowe\n• informacje o urządzeniu\n• adres IP\n• dane diagnostyczne i informacje o użyciu\n\nUżytkownicy w niektórych regionach mogą zostać poproszeni o zgodę przed wyświetleniem spersonalizowanych reklam.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK korzysta z Firebase Crashlytics, aby pomagać w identyfikacji awarii i poprawie stabilności aplikacji.\n\nRaporty o awariach mogą zawierać informacje techniczne takie jak:\n\n• model urządzenia\n• wersja systemu operacyjnego\n• wersja aplikacji\n• diagnostyka awarii\n\nRaporty o awariach celowo nie zawierają Twoich ocen produktów, notatek, list zakupów ani zdjęć.",
      },
      externalProductDatabases: {
        title: "Zewnętrzne bazy produktów",
        body: "Funkcja wyszukiwania kodów kreskowych może korzystać z zewnętrznych baz produktów w celu pobrania informacji o produktach.\n\nWięcej informacji znajdziesz w politykach prywatności odpowiednich dostawców.",
      },
    },
    dataSecurity: {
      title: "Bezpieczeństwo danych",
      body: "WasOK przechowuje dane aplikacji lokalnie na Twoim urządzeniu, korzystając z mechanizmów pamięci zapewnianych przez system operacyjny.\n\nChociaż podejmowane są rozsądne środki w celu ochrony lokalnych danych aplikacji, żadna metoda elektronicznego przechowywania nie jest całkowicie bezpieczna.\n\nUżytkownicy odpowiadają za utrzymywanie kopii zapasowych ważnych danych, jeśli sobie tego życzą.",
    },
    children: {
      title: "Prywatność dzieci",
      body: "WasOK nie jest skierowany do dzieci poniżej 13. roku życia.",
    },
    notifications: {
      title: "Powiadomienia",
      body: "WasOK może opcjonalnie tworzyć lokalne powiadomienia na Twoim urządzeniu, przypominając o ocenie produktów po zakupie.\n\nTe powiadomienia są generowane i planowane lokalnie na Twoim urządzeniu i nie wymagają konta ani zdalnego serwera.\n\nMożesz wyłączyć powiadomienia w dowolnym momencie w ustawieniach urządzenia lub w aplikacji, jeśli jest to obsługiwane.",
    },
    yourControl: {
      title: "Twoja kontrola nad danymi",
      body: "Możesz:\n\n• edytować lub usuwać zapisane produkty w dowolnym momencie\n• wyczyścić dane aplikacji na swoim urządzeniu\n• odinstalować aplikację\n• eksportować kopie zapasowe swoich danych",
    },
    changes: {
      title: "Zmiany w tej polityce",
      body: "Niniejsza Polityka prywatności może być od czasu do czasu aktualizowana.\n\nZmiany wchodzą w życie z chwilą opublikowania zaktualizowanej wersji.",
    },
    contact: {
      title: "Kontakt",
      body: "Jeśli masz pytania dotyczące niniejszej Polityki prywatności, skontaktuj się z:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Warunki korzystania",
    lastUpdated: "Ostatnia aktualizacja: 1 czerwca 2026",
    acceptance: {
      title: "Akceptacja warunków",
      body: "Pobierając, instalując lub korzystając z WasOK, zgadzasz się na niniejsze Warunki korzystania.\n\nJeśli nie zgadzasz się z tymi Warunkami, nie powinieneś korzystać z aplikacji.",
    },
    license: {
      title: "Licencja",
      body: "WasOK przyznaje Ci ograniczoną, niewyłączną, niezbywalną i odwołalną licencję na korzystanie z aplikacji zgodnie z niniejszymi Warunkami.",
    },
    acceptableUse: {
      title: "Dopuszczalne użytkowanie",
      body: "Zgadzasz się, że nie będziesz:\n\n• nadużywać aplikacji\n• zakłócać działania aplikacji\n• podejmować prób inżynierii wstecznej ani modyfikowania aplikacji\n• korzystać z aplikacji z naruszeniem obowiązujących przepisów prawa",
    },
    localData: {
      title: "Dane lokalne i kopie zapasowe",
      body: "WasOK przechowuje dane użytkownika lokalnie na urządzeniu.\n\nUżytkownicy odpowiadają za utrzymywanie kopii zapasowych ważnych danych, jeśli sobie tego życzą.\n\nChociaż funkcje tworzenia i przywracania kopii zapasowych mogą być dostępne, WasOK nie gwarantuje ochrony przed utratą, uszkodzeniem ani awarią przechowywanych danych.",
    },
    advertisements: {
      title: "Reklamy",
      body: "Aplikacja może wyświetlać reklamy dostarczane przez zewnętrznych partnerów reklamowych, w tym Google AdMob.",
    },
    noWarranty: {
      title: "Brak gwarancji",
      body: "WasOK jest dostarczany „tak jak jest” i „w miarę dostępności” bez jakichkolwiek gwarancji, wyraźnych ani dorozumianych.\n\nNie gwarantujemy, że:\n\n• aplikacja będzie zawsze dostępna\n• aplikacja będzie wolna od błędów\n• nigdy nie dojdzie do utraty danych\n• wszystkie funkcje będą działać bez przerwy na wszystkich urządzeniach",
    },
    limitationLiability: {
      title: "Ograniczenie odpowiedzialności",
      body: "W maksymalnym zakresie dozwolonym przez prawo WasOK i jego twórcy nie ponoszą odpowiedzialności za:\n\n• utratę danych\n• utratę zysków\n• problemy z urządzeniem\n• szkody pośrednie lub wynikowe\n• przerwy wynikające z korzystania lub niemożności korzystania z aplikacji",
    },
    thirdParty: {
      title: "Usługi stron trzecich",
      body: "Niektóre funkcje lub treści mogą opierać się na usługach stron trzecich, w tym dostawcach reklam oraz zewnętrznych usługach przechowywania/udostępniania wybranych przez użytkownika.\n\nWasOK nie ponosi odpowiedzialności za usługi stron trzecich ani ich polityki.",
    },
    productInformation: {
      title: "Informacje o produktach",
      body: "Niektóre szczegóły produktów mogą pochodzić z zewnętrznych usług wyszukiwania kodów kreskowych.\n\nWasOK nie gwarantuje dokładności, kompletności, dostępności ani przydatności informacji dostarczanych przez zewnętrzne źródła danych.\n\nUżytkownicy powinni w razie potrzeby samodzielnie weryfikować informacje o produktach.",
    },
    changesApp: {
      title: "Zmiany w aplikacji",
      body: "WasOK może zostać zmodyfikowany, zaktualizowany, zawieszony lub wycofany w dowolnym momencie bez wcześniejszego powiadomienia.",
    },
    changesTerms: {
      title: "Zmiany w niniejszych warunkach",
      body: "Niniejsze Warunki mogą być okresowo aktualizowane.\n\nDalsze korzystanie z aplikacji po wejściu w życie aktualizacji stanowi akceptację zmienionych Warunków.",
    },
    contact: {
      title: "Kontakt",
      body: "W sprawie pytań dotyczących niniejszych Warunków skontaktuj się z:\n\nsupport@wasok.app",
    },
  },
};
